module.exports = __webpack_public_path__ + "img/67RBayberryAve_Small.7ea20725.png";